import * as React from 'react';

import MercuryGate from '../assets/mercurygate-logo.png';

export default function MercuryGateLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  return <img src={MercuryGate} alt='MercuryGate logo' {...props} />;
}
